// 导入axios库
import axios from 'axios';

// 创建一个新的axios实例
const instance = axios.create({
  timeout: 5000,
});

// 拦截请求
instance.interceptors.request.use(
  config => {
    if (config.url.includes('/fetch-data-server/fetch/v1')) {
      config.headers['Source-Id'] = 'b2cweb-hsgtconnect';
      config.headers['Platform'] = 'web';
    }
    return config;
  },
  error => {
    window.console.log('request error', error);
    return Promise.resolve(null);
  }
);

// 拦截响应
instance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    window.console.log('response error', error);
    return Promise.resolve(null);
  }
);

export function get(url, params) {
  return new Promise(resolve => {
    instance.get(url, { params }).then(res => {
      resolve(res);
    });
  });
}

export function post(url, params) {
  return new Promise(resolve => {
    instance.post(url, params).then(res => {
      resolve(res);
    });
  });
}
